export default "__VITE_ASSET__7q2qA7Zz__"